import { OfferingTypeIcon, OfferingTypeIconGlyph } from "./offering-type-icon";
export var ProductIcon = OfferingTypeIcon;
export var ProductIconGlyph = OfferingTypeIconGlyph;